import React, { Component } from 'react';
import { Info, CheckCircle2, Wrench, Package } from 'lucide-react';
const partsList = ['Impellers', 'Pump Seals', 'Pump Housings', 'Mounting Brackets', 'Repair Kits', 'Replacement Motors & Components'];
export function RepairKits() {
  return <section className="w-full bg-white" data-id="element-292">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-293">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-294">
          {/* Intro + parts */}
          <div data-id="element-295">
            <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-3" data-id="element-296">
              Repair Kits & Replacement Pump Parts
            </h2>
            <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-297">
              Keep your systems running with replacement parts and rebuild kits
              for the pumps we carry.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-5" data-id="element-298">
              {partsList.map(part => <div key={part} className="flex items-center gap-2.5" data-id="element-299">
                  <CheckCircle2 className="w-4 h-4 text-marine-cyan flex-shrink-0" data-id="element-300" />
                  <span className="text-sm text-slate-700 font-medium" data-id="element-301">
                    {part}
                  </span>
                </div>)}
            </div>

            <div className="bg-marine-light/60 border border-marine-blue/20 rounded-lg p-4 flex items-start gap-3" data-id="element-302">
              <Info className="w-5 h-5 text-marine-blue flex-shrink-0 mt-0.5" data-id="element-303" />
              <p className="text-sm text-marine-navy leading-relaxed" data-id="element-304">
                Most kits are put together at the time of order, so quantity on
                hand may display as <strong data-id="element-305">0</strong> — these usually ship the
                same day.
              </p>
            </div>
          </div>

          {/* Kit cards */}
          <div className="space-y-4" data-id="element-306">
            <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm" data-id="element-307">
              <div className="flex items-start gap-4" data-id="element-308">
                <div className="bg-slate-100 p-2.5 rounded-md text-slate-600" data-id="element-309">
                  <Wrench className="w-5 h-5" data-id="element-310" />
                </div>
                <div data-id="element-311">
                  <h3 className="text-lg font-bold text-marine-navy mb-1.5" data-id="element-312">
                    Minor Repair Kits
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed" data-id="element-313">
                    Include the impeller and gasket or O-ring for that pump.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white border border-marine-blue/30 rounded-lg p-5 shadow-sm ring-1 ring-marine-blue/5" data-id="element-314">
              <div className="flex items-start gap-4" data-id="element-315">
                <div className="bg-marine-blue p-2.5 rounded-md text-white" data-id="element-316">
                  <Package className="w-5 h-5" data-id="element-317" />
                </div>
                <div data-id="element-318">
                  <h3 className="text-lg font-bold text-marine-navy mb-1.5" data-id="element-319">
                    Major Repair Kits
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed" data-id="element-320">
                    Include every replacement part the pump requires except for
                    the shaft and body of the pump.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}